'use strict';

/**
 * mailto decorator implementation for the link module.
 *
 * @author Zorica Janjic <zorica.janjic@namics.com>
 */
T.Module.Link.Mailto = T.createDecorator({

	_selectors: {
		pageTitle: '.a-pagetitle'
	},

	start: function start(resolve) {

		// References
		this.$ctx = $(this._ctx);
		this.pageTitle = $(this._selectors.pageTitle).first().text();

		// Component Event Binding
		this.$ctx.on('click', this.linkTo_UnCryptMailto.bind(this));

		this._parent.start(resolve);
	},


	/**
  *  Converting link to decrypted mailTo
  *  ( Decrypting spam protected emails )
  *
  *	@param {MouseEvent} event - click event
  * 	@returns {boolean} false in case of empty encrypted string
  */
	linkTo_UnCryptMailto: function linkTo_UnCryptMailto(event) {
		event.preventDefault();

		var $encryptedEmail = $(event.currentTarget);
		var encryptedString = $encryptedEmail.data('mailaddr-enc');

		if (!encryptedString) {
			return false;
		}

		var mailto = this.decryptString(encryptedString, -1);
		var subject = '';

		location.href = mailto + subject;
	},


	// Decrypt helper function
	decryptCharcode: function decryptCharcode(n, start, end, offset) {
		n = n + offset;
		if (offset > 0 && n > end) {
			n = start + (n - end - 1);
		} else if (offset < 0 && n < start) {
			n = end - (start - n - 1);
		}
		return String.fromCharCode(n);
	},


	/**
  *  Decrypting string function
  *	@param {string} enc - Encrypted string
  *	@param {number} offset used for decryption
  * 	@returns {string} dec - string decrypted to mailto
  */
	decryptString: function decryptString(enc, offset) {
		var dec = '';
		var len = enc.length;
		for (var i = 0; i < len; i++) {
			var n = enc.charCodeAt(i);
			if (n >= 0x2B && n <= 0x3A) {
				// 0-9 . , - + / :
				dec += this.decryptCharcode(n, 0x2B, 0x3A, offset);
			} else if (n >= 0x40 && n <= 0x5A) {
				// A-Z @
				dec += this.decryptCharcode(n, 0x40, 0x5A, offset);
			} else if (n >= 0x61 && n <= 0x7A) {
				// a-z
				dec += this.decryptCharcode(n, 0x61, 0x7A, offset);
			} else {
				dec += enc.charAt(i);
			}
		}
		return dec;
	}
});